var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DamageMap, LoadingOne } from '@icon-park/react';
import { EventChannel } from '@syllepsis/adapter';
import cls from 'classnames';
import debounce from 'lodash.debounce';
import React from 'react';
import { Icons } from '../../../component/icons';
import { ImageResizeBox } from './image-resize-box';
var DEFAULT_IMG_SIZE;
(function (DEFAULT_IMG_SIZE) {
    DEFAULT_IMG_SIZE[DEFAULT_IMG_SIZE["width"] = 375] = "width";
    DEFAULT_IMG_SIZE[DEFAULT_IMG_SIZE["height"] = 300] = "height";
})(DEFAULT_IMG_SIZE || (DEFAULT_IMG_SIZE = {}));
var SylMaskImageFailed = function (_a) {
    var attrs = _a.attrs, maxWidth = _a.maxWidth, rest = __rest(_a, ["attrs", "maxWidth"]);
    var width = attrs.width, align = attrs.align;
    var displayWidth = width || Math.min(DEFAULT_IMG_SIZE.width, maxWidth);
    return (React.createElement("div", __assign({ className: "syl-image-failed-wrapper", style: { textAlign: align } }, rest),
        React.createElement("div", { className: "syl-image-failed", style: { width: displayWidth + "px", height: (displayWidth * 9) / 16 + "px" } },
            React.createElement("span", { className: "syl-image-icon" },
                React.createElement(DamageMap, { size: displayWidth / 6, fill: "#999" })))));
};
var ImageMask = /** @class */ (function (_super) {
    __extends(ImageMask, _super);
    function ImageMask(props) {
        var _this = _super.call(this, props) || this;
        _this.isInline = false;
        _this.imageMount = false;
        _this.inputting = false;
        _this.isResizing = false;
        _this.localeUpdate = debounce(function () { return _this.imageMount && _this.forceUpdate(); }, 300, {
            leading: true,
        });
        _this._handleCheckStatus = function (e) {
            if (e.target &&
                _this.imageWrapDom &&
                e.target.tagName.toLowerCase() !== 'input' &&
                _this.imageWrapDom.contains(e.target) &&
                !_this.state.active) {
                _this.setState({ active: true });
            }
        };
        _this.focusCaption = function () {
            _this.props.editor.disable();
            _this.setState({ active: false });
            _this.inputting = true;
        };
        _this.updateCaptionValue = function (e) {
            var caption = _this.state.caption;
            var _a = _this.props, editor = _a.editor, attrs = _a.attrs;
            editor.enable();
            if (caption !== attrs.alt)
                _this.dispatchUpdate({ alt: caption });
            _this.inputting = false;
        };
        _this.dispatchUpdate = function (attrs) {
            var pos = _this.props.getPos();
            if (pos === undefined)
                return;
            _this.props.editor.updateCardAttrs(pos, attrs);
        };
        _this.updateImageUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var uploadPromise, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        uploadPromise = this.props.editor.command.image.updateImageUrl(this.props, this.props.dispatchUpdate);
                        if (this.state && this.state.isUploading !== this.props.state.uploading) {
                            this.setState({
                                isFailed: false,
                                isUploading: Boolean(this.props.state.uploading),
                            });
                        }
                        return [4 /*yield*/, uploadPromise];
                    case 1:
                        _a.sent();
                        if (!this.imageMount)
                            return [2 /*return*/];
                        this.setState({
                            isUploading: false,
                            isFailed: false,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (!this.imageMount)
                            return [2 /*return*/];
                        this.setState({
                            isFailed: true,
                            isUploading: false,
                        });
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this._onResizeStart = function () {
            _this.isResizing = true;
        };
        _this._onResizeEnd = function (width, height) {
            _this.dispatchUpdate({
                width: width,
                height: height,
            });
            _this.isResizing = false;
        };
        _this._changeAlt = function (e) {
            _this.setState({
                caption: e.target.value,
            });
        };
        _this.renderImage = function () {
            var _a = _this.state, active = _a.active, isUploading = _a.isUploading;
            var _b = _this.props, attrs = _b.attrs, editor = _b.editor;
            var src = attrs.src, alt = attrs.alt, width = attrs.width, height = attrs.height;
            var config = editor.command.image.getConfiguration();
            return (React.createElement("span", { className: "syl-image-atom-wrapper", ref: function (ref) { return _this.isInline && (_this.imageWrapDom = ref); } },
                React.createElement("img", __assign({ src: src }, (alt ? { alt: alt } : {}), (width ? { width: width } : {}), (height ? { height: height } : {}), { onError: function () {
                        _this.setState({
                            isFailed: true,
                        });
                    } })),
                editor.editable && !config.disableResize && active ? (React.createElement(ImageResizeBox, { height: height, onResizeStart: _this._onResizeStart, onResizeEnd: _this._onResizeEnd, editorDOM: editor.view.dom, src: src, width: width, targetDOM: _this.imageWrapDom })) : null,
                isUploading &&
                    (config.renderLoading ? (config.renderLoading(_this.props)) : (React.createElement("div", { className: "syl-image-loading" },
                        React.createElement(LoadingOne, { theme: "outline", size: "20", fill: "#fff" }))))));
        };
        _this.renderBlockImage = function () {
            var _a = _this.props, attrs = _a.attrs, editor = _a.editor;
            var align = attrs.align;
            var locale = editor.configurator.getLocaleValue('image');
            var active = _this.state.active;
            var config = editor.command.image.getConfiguration();
            return (React.createElement("div", { ref: function (ref) { return (_this.imageWrapDom = ref); }, className: cls('syl-image-wrapper'), style: { textAlign: align } },
                React.createElement("div", { className: "syl-image-fixer" },
                    active && editor.editable && !config.disableAlign && (React.createElement("span", { className: "align-menu" },
                        React.createElement("span", { className: cls('align-icon', { active: align === 'left' }), onClick: function () { return _this.dispatchUpdate({ align: 'left' }); } }, Icons.align_left),
                        React.createElement("span", { className: cls('align-icon', { active: align === 'center' }), onClick: function () { return _this.dispatchUpdate({ align: 'center' }); } }, Icons.align_center),
                        React.createElement("span", { className: cls('align-icon', { active: align === 'right' }), onClick: function () { return _this.dispatchUpdate({ align: 'right' }); } }, Icons.align_right))),
                    _this.renderImage(),
                    config.disableCaption !== true && (React.createElement("div", { className: "syl-image-caption" },
                        React.createElement("input", { type: "text", maxLength: config.maxLength || 20, placeholder: config.placeholder || locale.placeholder || "\u56FE\u7247\u63CF\u8FF0(" + config.maxLength + "\u5B57\u5185)", className: "syl-image-caption-input", draggable: true, onDragStart: function (e) {
                                e.preventDefault();
                                e.nativeEvent.stopImmediatePropagation();
                            }, onCopy: function (e) {
                                var selection = window.getSelection();
                                if (selection) {
                                    e.clipboardData.setData('text/html', selection.toString());
                                }
                            }, onFocus: _this.focusCaption, onChange: _this._changeAlt, onMouseUp: function (e) { return e.nativeEvent.stopImmediatePropagation(); }, onBlur: _this.updateCaptionValue, value: _this.state.caption, onClick: function (e) {
                                e.stopPropagation();
                            } }))))));
        };
        _this.renderFailedImage = function (config) {
            if (config.renderFailed)
                return config.renderFailed(__assign(__assign({}, _this.props), { reUpload: _this.updateImageUrl }));
            return React.createElement(SylMaskImageFailed, { attrs: _this.props.attrs, maxWidth: config.uploadMaxWidth });
        };
        var editor = props.editor, attrs = props.attrs, state = props.state;
        _this.updateImageUrl();
        _this.state = {
            caption: attrs.alt || '',
            active: false,
            isUploading: Boolean(state.uploading),
            isFailed: false,
        };
        var schema = editor.view.state.schema;
        _this.isInline = schema.nodes.image.isInline;
        _this.MAX_WIDTH = editor.view.dom.scrollWidth - 40;
        return _this;
    }
    ImageMask.prototype.componentDidUpdate = function (prevProps) {
        if (!this.inputting && this.props.attrs.alt !== undefined && this.props.attrs.alt !== this.state.caption) {
            this.setState({
                caption: this.props.attrs.alt || '',
            });
        }
        if (this.props.attrs.src !== prevProps.attrs.src) {
            this.props.state.uploading = false;
            this.updateImageUrl();
        }
        if (!this.isResizing && this.props.isSelected !== prevProps.isSelected) {
            this.setState({ active: this.props.isSelected });
        }
    };
    ImageMask.prototype.componentDidMount = function () {
        document.addEventListener('click', this._handleCheckStatus);
        this.props.editor.on(EventChannel.LocalEvent.LOCALE_CHANGE, this.localeUpdate);
        this.imageMount = true;
    };
    ImageMask.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this._handleCheckStatus);
        this.props.editor.off(EventChannel.LocalEvent.LOCALE_CHANGE, this.localeUpdate);
        this.imageMount = false;
    };
    ImageMask.prototype.render = function () {
        var _a = this.state, isFailed = _a.isFailed, isUploading = _a.isUploading;
        if (isFailed && !isUploading) {
            var config = this.props.editor.command.image.getConfiguration();
            if (config.renderFailed !== false)
                return this.renderFailedImage(config);
        }
        return this.isInline ? this.renderImage() : this.renderBlockImage();
    };
    return ImageMask;
}(React.Component));
export { ImageMask, SylMaskImageFailed };
//# sourceMappingURL=mask.js.map